import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=6e68fe98&scoped=true&"
import script from "./Variable.vue?vue&type=script&lang=js&"
export * from "./Variable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68fe98",
  null
  
)

export default component.exports